import VerticalTabs from "common/ComponentSidebar/ComponentSideBar";
import { checkPrivileges } from "Helpers/CheckPrivileges";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { StoreProfileService } from "subModule/src/core/services";
import { isBinInventoryMode } from "./Racks/rackUtils";

interface tabProps {
  params: any;
  selectedIndex: number;
  /** Prefer this over a second getStoreByID (avoids cancel-token race). */
  inventoryMode?: string | number | null;
  /** Force show racks tab (e.g. already on racks routes). */
  showRacks?: boolean;
}

export default function StoreTabs(props: tabProps) {
  const navigate = useNavigate();
  const hasModeProp = props.inventoryMode !== undefined || props.showRacks;
  const [isBinMode, setIsBinMode] = useState(() =>
    props.showRacks
      ? true
      : props.inventoryMode !== undefined
        ? isBinInventoryMode(props.inventoryMode)
        : false,
  );

  useEffect(() => {
    if (props.showRacks) {
      setIsBinMode(true);
      return;
    }
    if (props.inventoryMode !== undefined) {
      setIsBinMode(isBinInventoryMode(props.inventoryMode));
      return;
    }

    const storeId = Number(props.params?.id);
    if (!storeId) {
      setIsBinMode(false);
      return;
    }

    let active = true;
    StoreProfileService.getStoreByID(storeId)
      .then((res) => {
        if (!active) return;
        setIsBinMode(
          !!(res?.success && isBinInventoryMode(res?.data?.inventoryMode)),
        );
      })
      .catch((err) => {
        // Canceled by another StoreProfile GET — keep current state
        if (
          !err ||
          err?.code === "ERR_CANCELED" ||
          err?.name === "CanceledError" ||
          err?.message === "New request initiated"
        ) {
          return;
        }
        if (active) setIsBinMode(false);
      });

    return () => {
      active = false;
    };
  }, [props.params?.id, props.inventoryMode, props.showRacks, hasModeProp]);

  const handleChangeTabs = (tabId: number) => {
    if (tabId === 0) navigate(`/store/${props.params?.id}`);
    else if (tabId === 1 && isBinMode)
      navigate(`/store/${props.params?.id}/racks`);
  };

  const tabs = [
    { id: 0, title: `edit`, child: <></> },
    ...(isBinMode ? [{ id: 1, title: `racks`, child: <></> }] : []),
  ];

  const disableTabs = tabs
    .map((tab) => tab.id)
    .filter((tabId) => {
      switch (tabId) {
        case 0:
          return !checkPrivileges("ROLE_STORE_UPDATE");
        case 1:
          return !checkPrivileges("ROLE_STORE_VIEW");
        default:
          return false;
      }
    });

  return (
    <>
      <VerticalTabs
        tabs={tabs}
        selectedIndex={props.selectedIndex}
        handleChangeTabs={handleChangeTabs}
        disableTabNo={disableTabs}
      />
    </>
  );
}
